import { useState } from "react"
import PropTypes from "prop-types"
import { Button } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"
import VisuallyHidden from "@reach/visually-hidden"
import { DialogOverlay, DialogContent } from "@reach/dialog"

const Modal = ({
  children,
  triggerText,
  headerText,
  onConfirmClick,
  showCloseButton = true,
  confirmButtonText = "Submit",
  confirmButtonProps = {},
  buttons = [],
  triggerProps = {},
  overlayProps = {},
  containerProps = {},
  headerProps = {},
  bodyProps = {},
  footerProps = {},
  wrapperProps = {}
}) => {
  const [showModal, setShowModal] = useState(false)

  const handleOpen = () => setShowModal(true)
  const handleClose = () => setShowModal(false)

  const showSuccessButton = buttons.length === 0

  const handleConfirmation = onButtonClick => onButtonClick(handleClose)

  return (
    <div {...wrapperProps}>
      <Button title={triggerText} onClick={handleOpen} size="xs" {...triggerProps} />

      {showModal && (
        <DialogOverlay
          onDismiss={handleClose}
          style={{ background: "hsla(0, 0%, 0%, 0.4)", zIndex: 1000 }}
          {...overlayProps}
        >
          <DialogContent
            aria-labelledby={headerText}
            className="modal d-b"
            style={{ padding: "2rem 0 0 0" }}
            {...containerProps}
          >
            <div className="modal__header" {...headerProps}>
              <h1 className="modal-title">{headerText}</h1>
              {showCloseButton && (
                <button className="modal__close-button" onClick={handleClose}>
                  <VisuallyHidden>Close</VisuallyHidden>
                  <Icon symbol="general#x" aria-label="Close Modal" />
                </button>
              )}
            </div>

            <div className="modal__body" {...bodyProps}>
              {children}
            </div>

            <div className="modal__footer ta-r" {...footerProps}>
              {showSuccessButton && (
                <Button
                  title={confirmButtonText}
                  onClick={() => handleConfirmation(onConfirmClick)}
                  theme="create"
                  size="sm"
                  marginLeft={1}
                  {...confirmButtonProps}
                />
              )}

              {buttons.map(({ onClick, text, ...props }) => (
                <Button
                  title={text}
                  key={text}
                  size="sm"
                  marginLeft={1}
                  onClick={() => handleConfirmation(onClick)}
                  {...props}
                />
              ))}
            </div>
          </DialogContent>
        </DialogOverlay>
      )}
    </div>
  )
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  triggerText: PropTypes.string.isRequired,
  headerText: PropTypes.string,
  onConfirmClick: PropTypes.func,
  showCloseButton: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  confirmButtonProps: PropTypes.shape({}),
  buttons: PropTypes.array,
  triggerProps: PropTypes.shape({}),
  overlayProps: PropTypes.shape({}),
  containerProps: PropTypes.shape({}),
  headerProps: PropTypes.shape({}),
  bodyProps: PropTypes.shape({}),
  footerProps: PropTypes.shape({}),
  wrapperProps: PropTypes.shape({})
}

export default Modal
